export const AdPlacementsGroupType = {
  searchImageAd: 'searchImageAd',
  msanImageAd: 'msanImageAd',
  imageExtension: 'imageExtension',
  perfMax: 'perfMax',
  streamlinedSignup: 'streamlinedSignup',
  adLibrary: 'adLibrary',
  msanBoostImageAd: 'msanBoostImage',
  appAd: 'appAd',
  appAdStart: 'appAdStart',
  responsiveSearchAd: 'responsiveSearchAd',
  dynamicSearchAd: 'dynamicSearchAd',
};

export const AdPlacementsComponentTypes = {
  AdPlacementPreview: 'AdPlacementPreview',
  AdPlacementDynamicSearch: 'AdPlacementDynamicSearch',
  AdPlacementResponsiveSearch: 'AdPlacementResponsiveSearch',
  AdPlacementResponsiveSearchDesktop: 'AdPlacementResponsiveSearchDesktop',
  AdPlacementResponsiveSearchMobile: 'AdPlacementResponsiveSearchMobile',
};
